import {
  ActividadEconomica,
  ActividadEconomicaFiltro,
  ActividadEconomicaPageResponse
} from '../../model/actividad-economica/actividad-economica';

/**
 * Puerto: ActividadEconomicaRepository
 *
 * Define el contrato para acceso a datos de actividades económicas (CIIU),
 * con paginación keyset/cursor (skill acceso-datos-oracle §7 — nunca OFFSET).
 * La implementación concreta está en infrastructure/adapters/actividad-economica/
 *
 * Arquitectura Hexagonal:
 * - Presentation → inyecta este PUERTO (abstract class)
 * - Infrastructure → implementa este puerto (HttpActividadEconomicaRepository)
 *
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class ActividadEconomicaRepository {

  /**
   * Busca actividades económicas con filtros y paginación keyset/cursor.
   *
   * @param filtro Filtros de búsqueda
   * @param cursor Cursor de la página (null = primera página)
   * @param size Tamaño de página
   * @param direction NEXT | PREVIOUS | LAST
   */
  abstract search(
    filtro: ActividadEconomicaFiltro,
    cursor: string | null,
    size: number,
    direction: 'NEXT' | 'PREVIOUS' | 'LAST'
  ): Promise<ActividadEconomicaPageResponse>;

  /**
   * Obtiene una actividad económica por código CIIU
   */
  abstract getByCodigo(codigo: string): Promise<ActividadEconomica>;
}
